import { Link as MuiLink, type LinkProps as MuiLinkProps } from '@mui/material';

export type LinkMuiProps = MuiLinkProps;

export const LinkMui = (props: Readonly<LinkMuiProps>) => <MuiLink {...props} />;
